import { faGithub } from '@fortawesome/free-brands-svg-icons';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Row } from 'react-bootstrap';
import ProjectModal from '../ProjectModal/ProjectModal';
import './Projects.css';

const elementGithub = <FontAwesomeIcon icon={faGithub} />
const elementExternalLinkAlt = <FontAwesomeIcon icon={faExternalLinkAlt} />

const Projects = () => {

    const [fullscreen, setFullscreen] = useState(true);
    const [show, setShow] = useState(false);
    const [projects, setData] = useState([]);
    // const [id, project_name] = data;

    const [project_name, technology, id] = projects;

    useEffect(() => {
        fetch('./data.json')
            .then(res => res.json())
            .then(data => setData(data))
    }, [])
    const handleShow = (breakpoint) => {
        setFullscreen(breakpoint);
        setShow(true);
    }

    return (
        <Container id="projects" className="projects my-5 py-5">
            <h2 style={{ color: "#CCD6F6", fontWeight: "bold", marginBottom: "50px" }}>My Projects <hr /></h2>

            {
                projects.map(data => <Row className="banner-text">
                    <Col md={7} >
                        <img className="w-100" src={data.image1} alt="" />
                    </Col>
                    <Col md={5} className="project-text project-single">
                        <p className="name">Featured Project</p>
                        <h3 style={{ fontWeight: "bold" }}>{data.project_name} <br /></h3>
                        <p className="paragraph-bg my-5" style={{ color: "#8892B0" }}>
                            {data.short_description} <br />
                            {data.description}</p>
                        <p className="tech">{data.technology}</p>
                        <a href="https://github.com/auladhimel/droneZilla-drone-buying-client-side" target="_blank" style={{ color: "#8892B0", fontSize: "25px" }}>{elementGithub}</a> &nbsp; &nbsp;
                        <a href={data.live_site} target="_blank" style={{ color: "#8892B0", fontSize: "23px" }}>{elementExternalLinkAlt}</a> &nbsp; &nbsp;
                        {/* <a onClick={handleShow} className="custom-button" style={{ marginTop: "0px", textDecoration: "none" }} >Details</a> */}
                    </Col>
                    <ProjectModal
                        projects={projects}
                        fullscreen={fullscreen}
                        show={show}
                        handleShow={handleShow}
                        setShow={setShow}
                    ></ProjectModal>
                </Row>)
            }

        </Container>
    );
};

export default Projects;